import { Link } from 'react-router-dom';
import packageJson from '../../../../../package.json';
import Button from '../../../components/Button';

export const PatchNotesComponent = () => {
    const packageVersion = packageJson?.version;

    return (
        <div className="text-1.6rem mt-5 text-textPrimary">
            <Link to="/patch-notes" className="w-full h-full">
                <Button disabled className="w-full text-primary hover:bg-blue-100 rounded-xl">V: {packageVersion}</Button>
            </Link>
        </div>
    )
}